export default __webpack_public_path__ + "static/media/logo-ae-noon.a2153a55.svg";